import React from "react";

const SEOCertification = () => {
  const images = [
    {
      src: "/Images/logomars.png",
      alt: "Image 1",

      definition: "Finance",
    },
    {
      src: "/Images/logosr.png",
      alt: "Image 2",
      definition: "Production",
    },
    {
      src: "/Images/logomart.png",
      alt: "Image 3",

      definition: "Technology",
    },
    {
      src: "/Images/logoaviaWell.png",
      alt: "Image 4",
      definition: "Financial Services",
    },
    {
      src: "/Images/logoElite.png",
      alt: "Image 5",

      definition: "Investment",
    },
    {
      src: "/Images/logossenter.png",
      alt: "Image 6",
      definition: "Trade",
    },
    {
      src: "/Images/logoanushka.png",
      alt: "Image 7",

      definition: "Investment",
    },
    {
      src: "/Images/logomainpri.png",
      alt: "Image 8",
      definition: "Trade",
    },
  ];
  return (
    <div className="px-[6%] py-[6%]">
      <div className="text-[2.5rem] mb-4  text-center font-[500] leading-[1.2]">
        <b>Our Certifications</b>
      </div>
      <div className="lg:flex justify-between mt-[5%] flex-wrap">
        <div className="lg:w-1/2">
          <p className="font-[400] text-[18px]  mb-4 leading-[1.2] my-[2%]">
            Our company, Abscod, has been recognized with numerous awards and
            accolades from top digital marketing organizations around the world.
            Our expertise in various digital marketing services has earned us
            recognition in several streams, including SEO and 360-degree digital
            marketing.
          </p>
          <p className="font-[400] text-[18px] mb-4 leading-[1.2] my-[2%]">
            Recently in 2021, one of our own social media marketing move went
            globally viral which was seen and appreciated by the viewers of the
            world and was also covered in top print & digital medias of the
            world.
          </p>
          <p className="font-[400] text-[18px] mb-4 leading-[1.2] my-[2%]">
            You can search more about it by typing ‘Abscod’ on Google and click
            on the ‘News’ results.
          </p>
        </div>
        <div className="lg:w-1/2">
          <ul className="grid lg:grid-cols-4 md:grid-cols-4 grid-cols-2   leading-[1.2]">
            {images.map((image) => (
              <li
                // style={{ boxShadow: "4px 5px 15px 2px #dedede" }}
                key={image.id}
                // className=" flex flex-col items-center  rounded-[4px]  px-4 pt-3 "
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-[150px] p-5 "
                />

                {/* <p className="text-[22px]  text-center  mt-4 font-[500]">
                  {image.definition}
                </p> */}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SEOCertification;
